import styled from 'styled-components';
import { prop } from 'styled-tools';

export const Spinner = styled('div')`
  /* stylelint-disable */
  height: ${prop('size', '100px')};
  width: ${prop('size', '100px')};

  & svg {
    height: 100%;
    width: 100%;
  }
`;
